export default __webpack_public_path__ + "static/media/damilare.76486eef.jpg";